import CurrencyNumberFormatter from "./CurrencyNumberFormatter";

export default CurrencyNumberFormatter;
